import camelCase from 'lodash/camelCase';

function getTypedValue(value) {
  const couldBeJson =
    typeof value === 'string' && (value.indexOf('{') >= 0 || value.indexOf('[') >= 0);

  if (['true', 'false'].includes(value.toLowerCase())) {
    return value.toLowerCase() === 'true';
  }

  if (!Number.isNaN(Number(value)) && value !== '') {
    return Number(value);
  }

  if (typeof value === 'string' && !couldBeJson) {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    /* */
  }

  return value;
}

function getData(element, dataPrefix) {
  if (!element || !dataPrefix) {
    throw new ReferenceError('getData error. Usage: getData(element, dataPrefix)');
  }

  return Object.keys(element.dataset).reduce((acc, dataName) => {
    const reg = new RegExp(`^${dataPrefix.toLowerCase()}`);

    if (!dataName.match(reg, 'i')) {
      return acc;
    }

    const key = dataName.replace(reg, '');
    const snakeKey = camelCase(key.toLowerCase());

    acc[snakeKey] = getTypedValue(element.dataset[dataName]);

    return acc;
  }, {});
}

export default getData;
